import { navigate } from 'gatsby';
import React from 'react';
import { MainButton } from '../Buttons';
import { enterCheck } from './Constants';

type SearchButtonsType = {
	category: string;
	disabled: boolean;
	giveUp: () => void;
	gameOver: boolean;
	roundOver: boolean;
	nextRound: (arg0: string) => void;
	submitAnswer: () => void;
	shareText: () => string;
	useStaticQuery: string;
	showResults: boolean;
	setShowResults: (arg0: boolean) => void;
};
const SearchButtons = ({
	category,
	disabled,
	giveUp,
	gameOver,
	roundOver,
	nextRound,
	submitAnswer,
	shareText,
	useStaticQuery,
	showResults,
	setShowResults,
}: SearchButtonsType) => {
	const [copiedToClipboard, setCopiedToClipboard] = React.useState(false);

	const shareResult = () => {
		if (navigator.share) {
			return navigator.share({
				text: shareText(),
			});
		}
		setCopiedToClipboard(true);
		navigator.clipboard.writeText(shareText());
	};

	const startNextRound = () => {
		setCopiedToClipboard(false);
		if (useStaticQuery) {
			return navigate('/');
		}
		if (gameOver && !showResults && category !== 'Question of the Day') {
			return setShowResults(true);
		}
		return nextRound(category);
	};

	return (
		<div
			id="SearchButtons"
			style={{
				display: 'flex',
				justifyContent: 'center',
			}}>
			{roundOver ? (
				<>
					<MainButton
						onClick={startNextRound}
						onKeyDown={(event) => enterCheck(event) && startNextRound()}
						text={(() => {
							if (gameOver) {
								if (
									showResults ||
									category === 'Question of the Day' ||
									useStaticQuery
								) {
									return 'New Game';
								}
								return 'See Results';
							}
							return 'Next Round';
						})()}
					/>
					{!showResults && (
						<MainButton
							onClick={() => shareResult()}
							onKeyDown={(event) => enterCheck(event) && shareResult()}
							text={copiedToClipboard ? 'Copied to Clipboard' : 'Share'}
						/>
					)}
				</>
			) : (
				<>
					<MainButton
						disabled={disabled}
						onClick={() => submitAnswer()}
						onKeyDown={(event) => enterCheck(event) && submitAnswer()}
						text="Guess"
					/>
					<MainButton
						onClick={giveUp}
						onKeyDown={(event) => enterCheck(event) && giveUp()}
						text={useStaticQuery ? 'Reveal' : 'Give Up'}
					/>
				</>
			)}
		</div>
	);
};
export default SearchButtons;
